export default __webpack_public_path__ + "static/media/checked.fad16ef7.svg";